module.exports = __webpack_public_path__ + "img/newsImg8-2.f9477746.png";